import {postSignupFlowGuard} from "../../../router.helper";
import {AccountPageComponent} from "./account-page/account-page.component";
import {AccountSecurityPageComponent} from "./account-profile-page/account-security-page.component";
import {UnderConstructionPageComponent} from "../under-construction-page/under-construction-page.component";
import {AccountNotificationsPageComponent} from "./account-notifications-page/account-notifications-page.component";
import {HomeyRoute} from "../../app.routes";
import {AccountSubscriptionPageComponent} from "./account-subscription-page/account-subscription-page.component";
import {
  TermsAndConditionsPageComponent
} from "../extra-pages/terms-and-conditions-page/terms-and-conditions-page.component";
import {PrivacyPolicyPageComponent} from "../extra-pages/privacy-policy-page/privacy-policy-page.component";
import {AboutUsPageComponent} from "../extra-pages/about-us-page/about-us-page.component";
import {AccountHousingConnectComponent} from "./account-housing-connect/account-housing-connect.component";
import {AccountMyDataPageComponent} from "./account-my-data-page/account-my-data-page.component";

export const accountSectionRoute: HomeyRoute = {
  path: 'account',
  canActivate: [postSignupFlowGuard],
  children: [
    {path: '', pathMatch: 'full', component: AccountPageComponent},
    {path: 'login-details', component: AccountSecurityPageComponent},
    {path: 'security', redirectTo: 'login-details'},
    {path: 'my-data', component: AccountMyDataPageComponent},
    {path: 'notifications', component: AccountNotificationsPageComponent},
    {path: 'subscription', component: AccountSubscriptionPageComponent},
    {path: 'housing-connect', component: AccountHousingConnectComponent},
    {path: 'language', component: UnderConstructionPageComponent},
    {path: 'terms-and-conditions', component: TermsAndConditionsPageComponent},
    {path: 'privacy-policy', component: PrivacyPolicyPageComponent},
    {path: 'about', component: AboutUsPageComponent},
  ]
};
